import { useSession } from '../api/session';
import { useDeviceConfig } from '../api/config';
import { usePrefetchAll } from './usePrefetchAll';

/**
 * Invisible "on sign-in" hook runner - triggers the offline pre-cache
 * once the user is authed and we know this device's config. Mounted
 * inside AuthGate so it only runs for signed-in sessions.
 */
export function OfflinePrefetchBoot(): null {
  const { data: session } = useSession();
  const { data: dc } = useDeviceConfig();
  usePrefetchAll(session?.user?.id ?? null, dc);
  return null;
}
